import { Message } from "../interfaces/conversations.interface";

const messageFingerprint = (message: Message) =>
  [
    String(message.from?.id ?? ""),
    String(message.message ?? "").trim(),
    String(message.timestamp?.full ?? ""),
  ].join("|");

export const dedupeSocialMessages = (messages: Message[]) => {
  const seenIds = new Set<string>();
  const seenFingerprints = new Set<string>();

  return messages.filter((message) => {
    const id = String(message.id ?? "");
    if (id) {
      if (seenIds.has(id)) return false;
      seenIds.add(id);
    }

    const fingerprint = messageFingerprint(message);
    if (fingerprint && seenFingerprints.has(fingerprint)) return false;
    if (fingerprint) seenFingerprints.add(fingerprint);

    return true;
  });
};

export const isDuplicateSocialMessage = (
  messages: Message[],
  incoming: Message
) => {
  const incomingId = String(incoming.id ?? "");
  if (incomingId && messages.some((message) => String(message.id) === incomingId)) {
    return true;
  }

  const incomingFingerprint = messageFingerprint(incoming);
  return messages.some(
    (message) => messageFingerprint(message) === incomingFingerprint
  );
};
